import anixeFilters from "web/features/anixeFilters";
import app from "web/features/app";
import buyNow from "web/features/buyNow";
import cart from "web/features/cart";
import codes from "web/features/codes";
import customerMenu from "web/features/customerMenu";
import financingSources from "web/features/financingSources";
import subscriptionQuote from "web/features/subscriptionQuote";
import tourismAttributes from "web/features/tourismAttributes";
import tourismQuoteDomestic from "web/features/tourismQuoteDomestic";
import tourismQuoteInternational from "web/features/tourismQuoteInternational";

const reducer = {
  app,
  buyNow,
  cart,
  customerMenu,
  codes,
  tourismQuoteInternational,
  tourismQuoteDomestic,
  subscriptionQuote,
  financingSources,
  anixeFilters,
  tourismAttributes,
};

export default reducer;
